import { ItemList } from '../../orm'

class AdminServerSyncImport extends ItemList {
    getEntityKey() {
        return "admin/server_sync_import"
    }
}

export const adminServerSyncImport = new AdminServerSyncImport("admin_server_sync_import__default")
